import angular from 'angular'

import ownerCtrl from './owner.controller'
import ownerRoutes from './owner.routes'
import ownerRun from './owner.run'

const name = 'routingConsultOwner'

angular.module(name, [])
  .controller('ownerCtrl', ownerCtrl)
  .config(ownerRoutes)
  .run(ownerRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/owner/owner.module.js